import { BrainCircuit, Heart, ShieldCheck, Users } from "lucide-react";

const dataImages = [
  {
    src: "/About Us/Person 1.png",
    alt: "teacher 1 image",
  },
  {
    src: "/About Us/Person 2.png",
    alt: "teacher 2 image",
  },
  {
    src: "/About Us/Person 3.png",
    alt: "teacher 3 image",
  },
];

const coreValues = [
  {
    icon: Heart,
    title: "Student Empathy",
    desc: "We recognize the challenges involved in learning a new language and draw on our own experiences as learners to create a supportive and accessible learning environment.",
  },
  {
    icon: ShieldCheck,
    title: "Integrity",
    desc: "We are transparent about the commitment required to develop fluency and honest about the methods we use to support meaningful, lasting progress.",
  },
  {
    icon: Users,
    title: "Cultural Respect",
    desc: "We honor Indonesia’s cultural diversity by cultivating a deeper understanding and appreciation of its languages, traditions, and communities.",
  },
  {
    icon: BrainCircuit,
    title: "Innovation",
    desc: "We continuously evolve our platform to leverage the latest in educational psychology.",
  },
];

export { dataImages, coreValues };
